import { types, query, params, rawString } from 'typed-graphqlify';
import { gql } from '@apollo/client';
import { Types } from '@blumtechgroup/blum-ui-utils';

const _selectLocationsInitQuery = (organisationId: string) => ({
  organisations_by_pk: params(
    { id: rawString(organisationId) },
    {
      name: types.string,
    }
  ),
});

type X = Types.Unpacked<typeof _selectLocationsInitQuery>;
export type Organisation = X['organisations_by_pk'];

export const selectLocationsInitQuery = (organisationId: string) =>
  gql`
    ${query(_selectLocationsInitQuery(organisationId))}
  `;
